import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { postRegistration } from '../indexApi';
import { Context as AuthContext } from '../../../Redux/context/AuthContext';

const useCustomerData = () => {
  const [loading, setLoading] = useState(false);
  const [alertMsg, setAlertMsg] = useState({
    type: null,
    msg: null,
  });
  const [customerData, setCustomerData] = useState({
    ownerName: null,
    mobileNumber: null,
    city: null,
    category: null,
  });
  const [validated, setValidated] = useState(false);
  const [errorMsg, setErrorMsg] = useState({
    ownerName: null,
    mobileNumber: null,
    city: null,
    firmName: null,
    category: null,
    email: null,
  });
  const [showModal, setShowModal] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showWorkingHours, setShowWorkingHours] = useState(false);

  const { signin } = useContext(AuthContext);
  let history = useHistory();
  let location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    let valid = true;
    let msg = { ...errorMsg };
    let mob = /^[1-9]{1}[0-9]{9}$/;

    if (customerData.mobileNumber && mob.test(customerData.mobileNumber) == false) {
      msg.mobileNumber = true;
      valid = false;
    }
    if (!customerData.ownerName) {
      msg.ownerName = true;
      valid = false;
    }
    if (!customerData.mobileNumber) {
      msg.mobileNumber = true;
      valid = false;
    }
    if (!customerData.city) {
      msg.city = true;
      valid = false;
    }

    if (valid) {
      setValidated(true);
      await registrationRequest();
    }
    setErrorMsg(msg);
  };

  const registrationRequest = async () => {
    let obj = {
      ownerName: customerData.ownerName,
      mobileNumber: customerData.mobileNumber,
      city: customerData.city,
      category: customerData.category,
    };
    setLoading(true);
    await postRegistration(obj).then((res) => {
      if (res && res.data && res.data.status === 'success') {
        alert('Thank you for contacting us! We will get back to you soon.');
        window.location.reload(true);
      } else {
        alert(res.data.msg);
      }
    });
  };

  const updateCustomerData = (e) => {
    let obj = { ...customerData };
    let msg = { ...errorMsg };
    msg = {
      ownerName: false,
      mobileNumber: false,
      city: false,
      firmName: false,
      category: false,
      email: false,
    };
    obj[e.target.name] = e.target.value;

    setCustomerData(obj);
    setErrorMsg(msg);
  };

  const handleLoginSuccess = async (googleData, loginData) => {
    let { from } = location.state || {
      from: { pathname: '/dashboard', state: { source: 'from seller login' } },
    };

    const signInResp = await signin({ token: googleData?.tokenId, loginData: loginData || null });
    if (signInResp && signInResp.status && signInResp.status.toLowerCase() === 'success') {
      if (signInResp.login_data.tnc && signInResp.login_data.working) {
        history.replace(from);
      } else {
        if (signInResp && signInResp.login_data && !signInResp.login_data.tnc) {
          setShowTerms(true);
        }
        if (signInResp && signInResp.login_data && !signInResp.login_data.working) {
          setShowWorkingHours(true);
        }
        history.replace(from);
      }
    }
  };

  const handleLoginError = () => {
    alert('Error while login. Try after sometime.');
  };
  const onConfirm = () => {
    setShowModal(false);
  };
  const onCancel = () => {
    setShowModal(false);
  };
  return {
    loading,
    registrationRequest,
    customerData,
    setCustomerData,
    alertMsg,
    updateCustomerData,
    validated,
    handleSubmit,
    errorMsg,
    handleLoginSuccess,
    handleLoginError,
    showModal,
    showWorkingHours,
    showTerms,
    onConfirm,
    onCancel,
  };
};

export default useCustomerData;
